export default __webpack_public_path__ + "static/media/sounds/clpl_practice_correct_answer_selected_Alyx.mp3";